import { logger } from "@mwt/web-js-telemetry";

import {
  EHR_API_ENDPOINT,
  EHR_API_ENDPOINT_PATH,
  EHR_API_VALID_ENDPOINTS,
} from "../../environments/environment";

export function convertToHttpsHost(input: string) {
  // Remove any preceeding `protocol://` strings and add `https://`
  return "https://" + input.replace(/^(.*?)(:|)\/\//, "");
}

/**
 * A function to validate the passed endpoint
 * and return a valid endpoint href with appropriate API `path` in it
 * @param endpoint any string that can be a `host` of a URL
 * @returns Validated endpoint href
 */
export function getValidatedEndpoint(
  endpoint: string = EHR_API_ENDPOINT,
  path?: string | null
): string {
  let endpointUrl: URL;

  try {
    endpointUrl = new URL(convertToHttpsHost(endpoint));
    if (!EHR_API_VALID_ENDPOINTS.includes(endpointUrl.host)) {
      throw new Error(`invalid endpoint passed - ${endpoint}`);
    }
  } catch (error: any) {
    logger.debug(
      "[getValidatedEndpoint] - endpoint passed is not a URL - ",
      error
    );
    endpointUrl = new URL(convertToHttpsHost(EHR_API_ENDPOINT));
  }

  endpointUrl.pathname = path ?? EHR_API_ENDPOINT_PATH;
  return endpointUrl.href;
}
